import Vue from 'vue';
import ProfitableProducts from '@/plugins/graphql/queries/v2/ecommerce/profitable-products.gql';
/**
 * TODO: Optimize by initializing payload into model class instance
 * Expect to handle pagination
 */
export default Vue.extend({
    apollo: {
        profitableProducts: {
            query: ProfitableProducts,
            variables() {
                return {
                    appUuid: this.appUuid,
                    limit: this.perPage,
                };
            },
            update(data) {
                return data.mostSoldProducts;
            },
            fetchPolicy: 'cache-and-network',
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        perPage: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            profitableProducts: null,
        };
    },
    computed: {
        showLinkButton() {
            const products = this.profitableProducts;
            const fiveRecords = 5;
            if (!!products && products.edges.length >= fiveRecords) {
                return true;
            }
            return false;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                profitableProducts: this.profitableProducts,
                showLinkButton: this.showLinkButton,
            });
        }
    },
});
